import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useLayoutStore } from "../stores/LayoutStore";
import { Grid } from "antd";

function MobileMenuToggle() {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { collapsed, toggleCollapsed } = useLayoutStore();

  const openSideBar = () => {
    toggleCollapsed(false);
  };

  const closeSideBar = () => {
    toggleCollapsed(true);
  };

  return (
    <>
      {!screens.md && (
        <>
          {(collapsed && (
            <MenuUnfoldOutlined
              className="navbar-user-icon text-2xl!"
              onClick={() => openSideBar()}
            />
          )) ||
            (!collapsed && (
              <MenuFoldOutlined
                className="navbar-user-icon text-2xl!"
                onClick={() => closeSideBar()}
              />
            ))}
        </>
      )}
    </>
  );
}

export default MobileMenuToggle;
